var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 8.49996C0.666687 4.44987 3.94993 1.16663 8.00002 1.16663C12.0501 1.16663 15.3334 4.44987 15.3334 8.49996C15.3334 12.55 12.0501 15.8333 8.00002 15.8333C3.94993 15.8333 0.666687 12.55 0.666687 8.49996ZM8.00002 2.49996C4.68631 2.49996 2.00002 5.18625 2.00002 8.49996C2.00002 11.8137 4.68631 14.5 8.00002 14.5C11.3137 14.5 14 11.8137 14 8.49996C14 5.18625 11.3137 2.49996 8.00002 2.49996Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 7.83337C8.36817 7.83337 8.66665 8.13185 8.66665 8.50004V11.1667C8.66665 11.5349 8.36817 11.8334 7.99998 11.8334C7.63179 11.8334 7.33331 11.5349 7.33331 11.1667V8.50004C7.33331 8.13185 7.63179 7.83337 7.99998 7.83337Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99998,
    cy: 5.83329,
    r: 0.666667,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2158c345a19153e10d4940628923e08d.svg";
export { ForwardRef as ReactComponent };